import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import Swal from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  isLoading = false;
  showPassword = false;
  loading = false;
  public email = '';
  public password = '';
  form: FormGroup;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private httpClient: HttpClient
    ,
  ) {
    this.form = this.formBuilder.group({
      samAccountName: ['', [Validators.required, Validators.minLength(6)]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  togglePasswordVisibility() {
    // Cambia el estado de la visibilidad de la contraseña
    this.showPassword = !this.showPassword;

  }

  onEnter(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this.login();
    }
  }

  ngOnInit() {
    const token = this.authService.getToken();
  }

  login() {
    this.loading = true;
    const credentials = {
      is_login: 1,
      samAccountName: this.form.value.samAccountName,
      password: this.form.value.password,
    };
    this.authService.login(credentials).subscribe({
      // Manejar la respuesta del servicio de autenticación
      next: (data) => {

        console.log("data", data);
        if (!data.success) {
          const samAccountNameControl = this.form.get('samAccountName');
          const passwordControl = this.form.get('password');
          if (samAccountNameControl && passwordControl) {
            samAccountNameControl.setValue('');
            passwordControl.setValue('');
          }
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: data.errorMessage,
            allowOutsideClick: true, // Evita que se cierre al hacer clic fuera
            showConfirmButton: true, // No muestra el botón OK
          });
          this.loading = false;
        }
        else {
          this.loading = false;

          const localStorageContent = localStorage.getItem('Menu');

          // Verificar si el contenido no es null
          if (localStorageContent !== null) {
            // Parsear el contenido como un objeto JavaScript
            const parsedContent = JSON.parse(localStorageContent);

            // Acceder a la propiedad Dashboard
            const dashboardLink = parsedContent.Dashboard;

            location.href = '/home'//dashboardLink

            //this.authService.saveRoutesToLocalStorage();

            // this.router.navigate(['gasa/documentos/biblioteca']);
          }
        }
      },
      error: (error) => {
        this.loading = false;
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error en la solicitud de inicio de sesión',
          allowOutsideClick: true,
          showConfirmButton: true,
        });
      }
    });

  }

  get info() {
    return this.form.controls;
  }
}